// extracted by mini-css-extract-plugin
export default {"textArea":"textArea__VDUlm","modalContent":"modalContent__tY73t","hidden":"hidden__TYD3e"};